import { gql } from '../__generated__'

export const GET_MY_GOALS_COUNTERS = gql(`
  query GetMyGoalsCounters {
    getAssignedGoals {
      id
      status
      boards {
        id
      }
    }

    getOwnedGoals {
      id
      status
      boards {
        id
      }
    }

    getFollowedGoals {
      id
      status
      boards {
        id
      }
    }
  }
`)

export const GET_DASHBOARD_GOALS = gql(`
  query GetGoalsWithReminder($priorTo: TimestampInput!) {
    getGoalsWithReminder(priorTo: $priorTo) {
      ...DashboardGoalFragment
    }
  }
`)

export const GET_GOAL_DETAILS = gql(`
  query GetGoalDetails($input: GetGoalInput, $includeComments: Boolean = false, $includeGoalTree: Boolean = false, $includeTasks: Boolean = false, $includeProjects: Boolean = false, $includeFiles: Boolean = false, $includeResourcesForGoalTree: Boolean = false, $excludeCanceled: Boolean = true) {
    getGoal(input: $input) {
      ...GoalDetailsFragment,
      comments @include(if: $includeComments) {
        ...CommentFragment
      }
      goalTree @include(if: $includeGoalTree) {
        ...GoalTreeFragment
      }
      tasks(excludeCanceled: $excludeCanceled) @include(if: $includeTasks) {
        ...TaskListFragment
      }
      projects @include(if: $includeProjects) {
        ...GoalDetailsProjectsFragment
      }
      ...GoalResourcesFragment @include(if: $includeFiles)
    }
  }
`)

export const GET_GOAL_INFO = gql(`
  query GetGoalInfo($input: GetGoalInput) {
    getGoal(input: $input) {
      id
      name
      owner {
        ...AccountFragment
      }
    }
  }
`)

export const GET_GOAL_SECTIONS = gql(`
  query GetGoalSections($input: GetGoalInput) {
    getGoal(input: $input) {
      sections {
          id
          name
          board {
            id
            name
            userAccess
          }
        }
    }
  }
`)

export const GET_GOAL_INFO_SECTIONS = gql(`
  query GetGoalInfoSections($input: GetGoalInput) {
    getGoal(input: $input) {
      id
      name
      sections {
        id
        name
        board {
          id
          name
          userAccess
        }
      }
    }
  }
`)

export const GET_GOAL_BOARDS = gql(`
  query GetGoalBoards($input: GetGoalInput) {
    getGoal(input: $input) {
      boards {
        id
        name
        userAccess
      }
    }
  }
`)

export const GET_GOAL_TASKS = gql(`
  query GetGoalTasks($input: GetGoalInput, $excludeCanceled: Boolean) {
    getGoal(input: $input) {
      id
      tasks(excludeCanceled: $excludeCanceled) {
        ...TaskListFragment
      }
    }
  }
`)

export const GET_GOAL_DETAILS_COUNTERS = gql(`
  query GetGoalDetailsCounters($input: GetGoalInput, $includeResourcesForGoalTree: Boolean!, $excludeCanceled: Boolean = true) {
    getGoal(input: $input) {
      id
      commentsState {
        unreadCommentsCount
      }
      boards {
        id
      }
      projects {
        id
      }
      tasks(excludeCanceled: $excludeCanceled) {
        id
      }
      resources @skip(if: $includeResourcesForGoalTree) {
        id
      }
      resourcesForGoalTree @include(if: $includeResourcesForGoalTree) {
        id
      }
      goalTree {
        id
      }
    }
  }
`)

export const SEARCH_GOALS = gql(`
  query SearchGoals($input: SearchGoalsInput!) {
    searchGoals(input: $input) {
      goals {
        ...MyGoalFragment
      }
      meta {
        ...PaginationMetadataFragment
      }
    }
  }
`)
